module.exports = __webpack_public_path__ + "img/Metastasis-OSCC_GSE208253.70fd8c8b.png";